export default "__VITE_ASSET__B1Cse9di__"